<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='validation') 保存
    template(v-if='getPageType() !== "create"')
      el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit' @click="preview('ja')") プレビュー
    el-button(v-if='getPageType() !== "create"' type='danger' size='mini' icon='el-icon-delete' @click='onDelete') 削除
  .contents-container
    el-form.c-form(ref='form', :model='form', :rules='rules', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header.--c
            h1 タイトル
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.title.ja' placeholder='タイトルを入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.title.en' placeholder='タイトルを入力してください')

        section.c-form__item
          header.c-form__item__header.--c
            h1 クライアント名
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.caption.ja' placeholder='クライアント名を入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.caption.en' placeholder='クライアント名を入力してください')

        section.c-form__item
          header.c-form__item__header
            h1 ID
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item(prop="key")
                  el-input(v-model='form.key' placeholder='IDを入力してください')
                  p.caption URLに使われます。半角英数記号(_)のキャメルケースで入力してください。(e.g: emprire_of_the_sun)

        section.c-form__item
          header.c-form__item__header
            h1 ステータス
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='公開')
                  el-select(v-model='form.status')
                    el-option(v-for='item in OPTIONS.status', :key='item.value', :label='item.label', :value='item.value')
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='案件タイプ')
                  el-select(v-model='form.project_type')
                    el-option(v-for='item in OPTIONS.project', :key='item.value', :label='item.label', :value='item.value')
              el-col(:span='12')
                el-form-item(label='Featured')
                  el-select(v-model='form.is_featured')
                    el-option(v-for='item in OPTIONS.enabled', :key='item.value', :label='item.label', :value='item.value')
        section.c-form__item
          header.c-form__item__header
            h1 メディアタイプ
          .c-form__item__body
            el-form-item
              el-checkbox-group(v-model='form.media_type', :min='1')
                el-checkbox(v-for='tag in OPTIONS.work_media_type', :label='tag.id', :key='tag.id') {{tag.name}}
        section.c-form__item
          header.c-form__item__header
            h1 日時
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-date-picker(v-model='form.date', value-format='yyyy-MM-dd', type='date', placeholder='年月日を設定してください')

        section.c-form__item
          header.c-form__item__header.--c
            h1 説明文
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description.ja' placeholder='説明文を入力してください' type='textarea' :rows='20')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description.en' placeholder='説明文を入力してください' type='textarea' :rows='20')
              el-col(:span='24')
                p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;

        section.c-form__item
          header.c-form__item__header.--c
            h1 クレジット
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.credit.ja' placeholder='クレジットを入力してください' type='textarea' :rows='20')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.credit.en' placeholder='クレジットを入力してください' type='textarea' :rows='20')

        section.c-form__item
          header.c-form__item__header
            h1 メイン画像 or 埋め込み動画
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  upload-single(:form='form' datakey='main_video' type='nested' ratio='16_9')
                  p.caption 画像は一覧ページのサムネイルおよび動画が登録されてない場合の詳細ページメイン画像として使用されます。
              el-col(:span='12')
                el-form-item
                  el-input(v-model='form.main_video.video_uri' placeholder='動画サイトのURLを入力してください')
                  p.caption 動画のサムネイルは動画サービス側で設定してください。
        //- section.c-form__item
        //-   header.c-form__item__header
        //-     h1 サムネイル動画
        //-   .c-form__item__body
        //-     el-row(:gutter='20')
        //-       el-col(:span='12')
        //-         el-form-item
        //-           upload-single(:form='form' datakey='thumbnail' type='thumb' ratio='16_9')
        section.c-form__item
          header.c-form__item__header
            h1 画像
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  upload-multi(:form='form' datakey='images' ratio='16_9')
        section.c-form__item
          header.c-form__item__header
            h1 関連作品
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='showAddWorksModal()'  :disabled='form.related_works.length > 3') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='deleteWork()' :disabled='form.related_works.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable.c-list__works(v-model='form.related_works' element='ul')
                  li(v-for='(i, index) in form.related_works' :key='index')
                    template(v-if='getWorkImageUri(form.related_works[index])')
                      img.c-thumb__item--s(:src='getWorkImageUri(form.related_works[index])')
                    template(v-else)
                      .c-thumb__item--s
                        p no image
                    | {{getWorkString(form.related_works[index])}}
            el-row(:gutter='20')
              el-col(:span='12')
                p.caption.u-margin__top--s 最大四件設定、ステータスが非公開の場合は表示されません。
  modal-add-works-element(:visible='modalvisible' @hideModal='hideWorksModal')
</template>

<script type="text/javascript">
import form from '@/mixins/form'
import Sticky from '@/components/Element/Sticky'
import UploadSingle from '@/components/Element/Upload/Single'
import UploadMulti from '@/components/Element/Upload/MultiForWorks'
import ModalAddWorksElement from '@/components/Element/Modal/AddWorksElement'
import draggable from 'vuedraggable'
export default {
  name: 'PagesWorksDetail',
  mixins: [form],
  data () {
    return {
      modalvisible: false,
      rules: {
        key: [{ required: true, message: 'IDは必須です', trigger: 'blur' }]
      },
      initialForm: null, // 初期値
      form: {
        id: null,
        key: null,
        date: null,
        status: 0,
        title: {
          ja: null,
          en: null
        },
        caption: {
          ja: null,
          en: null
        },
        description: {
          ja: null,
          en: null
        },
        credit: {
          ja: null,
          en: null
        },
        main_video: {
          image: null,
          video_uri: null
        },
        thumbnail: {
          rectangle: null,
          video: null
        },
        is_featured: 0,
        media_type: [],
        project_type: 1,
        // additional_items: [],
        images: [],
        work_type: 1,
        related_works: []
      }
    }
  },
  methods: {
    showAddWorksModal (index) {
      this.modalvisible = true
    },
    /**
     * @param {Object} data
     */
    hideWorksModal (data) {
      this.modalvisible = false
      if (data.id) {
        this.form.related_works.push({
          id: data.id
        })
      }
    },
    deleteWork () {
      // 最後の要素から削除
      this.form.related_works.pop()
    },
    hasUnsavedChanges () {
      return JSON.stringify(this.form) !== JSON.stringify(this.initialForm)
    },
    validation () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onSave()
        } else {
          this.$message.error('入力内容に誤りがあります。')
          return false
        }
      })
    },
    preview (lang) {
      const openPreviewWindow = (lang) => {
        const path = lang === 'ja' ? '' : 'en/'

        const currentHost = location.hostname

        let previewBaseUrl

        if (currentHost === 'w0w-2024-cms.s2factory.co.jp') {
          previewBaseUrl = 'https://w0w-2024-www.s2factory.co.jp'
        } else if (currentHost === 'cms.w0w.co.jp') {
          previewBaseUrl = 'https://www.w0w.co.jp'
        } else {
          // デフォルト（予期しないホストの場合）
          previewBaseUrl = 'https://www.w0w.co.jp'
        }

        const url = `${previewBaseUrl}/${path}draft/works/${this.form.key}`
        window.open(url, '_blank')
      }
      if (this.hasUnsavedChanges()) {
        this.$confirm('未保存の変更があります。保存せずにプレビューしますか？', '確認', {
          confirmButtonText: 'はい',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          openPreviewWindow(lang)
        }).catch(() => {
        // キャンセルされた場合は何もしない
        })
      } else {
        openPreviewWindow(lang)
      }
    }
  },
  created () {
    this.getWorkType()
    this.init()
  },
  components: {
    Sticky,
    UploadSingle,
    UploadMulti,
    ModalAddWorksElement,
    draggable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Works/Detail/index.vue